
<div *ngIf="alerts && alerts.length>0">
  <div *ngFor="let alert of alerts" style="width:96%;margin:auto;">
    <alert [type]="alert.type"
           [dismissible]="dismissible"
           (onClosed)="onClosed(alert)">
      <span [innerHtml]="alert.msg"></span>
      <!--<strong>{{alert.displaytype}}!</strong>    {{ alert.msg }}-->
    </alert>
  </div>
</div>
